/* eslint-disable prettier/prettier */
export default {
    1: {
        en: 'It is simple and fun!',
        hi: 'यह सरल और मजेदार है!'
    },
    2: {
        en: 'For each question:',
        hi: 'प्रत्येक प्रश्न के लिए:'
    },
    3: {
        en: 'If you get your answer right, you get +5 POINTS.',
        hi: 'यदि आप अपना उत्तर सही पाते हैं, तो आपको 5 अंक मिलते हैं।'
    },
    4: {
        en: 'If you get your answer wrong, you get 0 POINTS.',
        hi: 'यदि आप अपना उत्तर गलत पाते हैं, तो आपको 0 अंक मिलते हैं।'
    },
    5: {
        en: '2x POWERUP rules:',
        hi: '2x पावरअप नियम:'
    },
    6: {
        en: 'If you choose 2x POWERUP in a question and get the answer right, you get +10 POINTS.',
        hi: 'यदि आप किसी प्रश्न पर 2x पावरअप चुनते हैं और सही उत्तर प्राप्त करते हैं, तो आपको 10 अंक मिलते हैं।'
    },
    7: {
        en: 'If you choose 2x POWERUP in a question and get the answer wrong, you get -10 POINTS.',
        hi: 'यदि आप किसी प्रश्न पर 2x पावरअप चुनते हैं और उत्तर गलत मिलता है, तो आपको -10 अंक मिलते हैं।'
    },
    8: {
        en: 'You can use 2x POWERUP in ALL THE QUESTIONS.',
        hi: 'आप सभी प्रश्नों पर 2x पावरअप का उपयोग कर सकते हैं।'
    },
    9: {
        en: 'Enjoy the game!!',
        hi: 'खेल का आनंद!!'
    }
} as any;
